import type { BackendRouteDefinition } from '../types';
import type { DisablePaymentInstrument } from '@cloudFunctions/index';

export const disablePaymentInstrumentRoute = {
  transport: 'api',
  method: 'PATCH',
  path: '/firms/buyer/payment-instruments/:paymentInstrumentId',
  params: ({ paymentInstrumentId }: DisablePaymentInstrument.RequestData) => ({
    paymentInstrumentId,
  }),
  body: ({ environment }: DisablePaymentInstrument.RequestData) => ({
    environment,
    disabled: true,
  }),
} as const satisfies BackendRouteDefinition;
